import { AlertCircle } from "lucide-react";
import React from "react";
import { Alert, Space, Text } from "@mantine/core";
import EmployerImporterMatchFieldTable from "../elements/EmployerMatchFieldTable";
import EmployerImporterReferenceFieldTable from "../elements/EmployerImporterReferenceFieldTable";

export type EmployeeDataImportColumnHeader = {
  name: string;
  relatedColumn: string;
  isTag: boolean;
};

export type rowsData = {
  [key: string]: string[];
};

type EmployeeImportMatchColumnPanelProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any;
  dataExtract?: rowsData;
};
const EmployeeImportMatchColumnPanel: React.FC<
  EmployeeImportMatchColumnPanelProps
> = ({ form, dataExtract }) => (
  <>
    <Space
      style={{
        paddingTop: "32px",
      }}
    />
    <Text
      style={{
        flexGrow: 0,
        fontFamily: "Inter",
        fontSize: "18px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        textAlign: "left",
        color: "var(--grey-grey-80)",
      }}
    >
      Match column properties
    </Text>
    <Space h="lg" />
    <Text
      style={{
        fontFamily: "Inter",
        fontSize: "14px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "1.43",
        letterSpacing: "0.16px",
        textAlign: "left",
        color: "var(--grey-grey-70)",
      }}
    >
      You can match columns from your upload with those on our system or assign
      them as tags.
    </Text>
    <Text
      style={{
        fontFamily: "Inter",
        fontSize: "14px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "1.43",
        letterSpacing: "0.16px",
        textAlign: "left",
        color: "var(--grey-grey-70)",
      }}
    >
      Any columns not matched will not be included in the import.
    </Text>
    <Space
      style={{
        paddingTop: "32px",
      }}
    />
    <Alert
      icon={
        <AlertCircle
          size={20}
          style={{
            color: "#ff922b",
          }}
        />
      }
      style={{
        height: "52px",
        alignSelf: "stretch",
        flexGrow: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "stretch",
        gap: "8px",
        padding: "16px",
        borderRadius: "8px",
        backgroundColor: "#fff5ea",
      }}
    >
      <Text
        style={{
          flexGrow: 0,
          fontFamily: "Inter",
          fontSize: "12px",
          fontWeight: 500,
          fontStretch: "normal",
          fontStyle: "normal",
          lineHeight: "1.33",
          letterSpacing: "0.16px",
          textAlign: "left",
          color: "#ff922b",
        }}
      >
        {
          form.values.columnHeaders.filter(
            (it: EmployeeDataImportColumnHeader) => !it.relatedColumn.length
          ).length
        }{" "}
        unmatched columns. Unmatched data won&rsquo;t be imported.
      </Text>
    </Alert>
    <Space h="xl" />

    <div
      style={{
        overflow: "auto",
        display: "flex",
        flexDirection: "row",
        marginLeft: "1rem",
        gap: "24px",
        height: "414px",
      }}
    >
      <div>
        <EmployerImporterMatchFieldTable
          rows={["Data extract", "Data extract", "Data extract"]}
        />
      </div>

      {form.values.columnHeaders.map(
        (row: EmployeeDataImportColumnHeader, index: number) => (
          <div key={`tRow-${Math.random()}`}>
            <div />
            <EmployerImporterReferenceFieldTable
              form={form}
              relatedColumn={row.relatedColumn}
              name={row.name}
              isTag={row.isTag}
              index={index}
              data={dataExtract ? dataExtract[row.name] : []}
            />
          </div>
        )
      )}
    </div>
  </>
);

export default EmployeeImportMatchColumnPanel;
